// @constants
const { THIRD_STEP, FOURTH_STEP } = require('constants/index');

// @ utils
const { isRenderStep0 } = require('mifid/utilities/mifidValidHelper')

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_VERIFY_ANSWERS,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CLOSE_INVALID_ANSWERS_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHANGE_EXPERIENCE_AS_INVESTOR
} = require('constants/actionTypes');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CONTINUE_WITH_INCOHERENCES,
} = require('mifid/constants/actionTypes');

const verifyAnswer = () => (dispatch, getState) => {
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const stepNumber = isRenderStep0() ? FOURTH_STEP : THIRD_STEP
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP3_VERIFY_ANSWERS,
        payload: {
            step: immBrokerConvenienceMiFIDTest.getIn(['steps', stepNumber, 'stepToCheckAnswer'])
        }
    });
};

const closeInvalidAnswersModal = () => (dispatch) => dispatch({
    type: BROKER_CONVENIENCE_MIFID_TEST_STEP3_CLOSE_INVALID_ANSWERS_MODAL,
    payload: {}
});

const changeProductExperience = (productId, experience) => dispatch => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHANGE_EXPERIENCE_AS_INVESTOR,
        payload: {
            productId,
            experience
        }
    });
};

const checkIncoherences = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHECK_INCOHERENCES
    });
}

const continueWithIncoherences = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP3_CONTINUE_WITH_INCOHERENCES
    })
}

module.exports = {
    verifyAnswer,
    closeInvalidAnswersModal,
    changeProductExperience,
    checkIncoherences,
    continueWithIncoherences
};
